import { render, staticRenderFns } from "./td-3d-arr-number.vue?vue&type=template&id=586d7999&"
import script from "./td-3d-arr-number.vue?vue&type=script&lang=js&"
export * from "./td-3d-arr-number.vue?vue&type=script&lang=js&"
import style0 from "./td-3d-arr-number.vue?vue&type=style&index=0&id=586d7999&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports